import colors from 'src/theme/colors';
import { defineSlotRecipe } from '@chakra-ui/react';
import Input from './Input';

const NumberInput = defineSlotRecipe({
  slots: ['root', 'input', 'control', 'incrementTrigger', 'decrementTrigger', 'valueText'],
  base: {
    input: {
      ...Input.base,
      verticalAlign: 'top',
      borderRadius: '12px',
    },
    root: {
      outlineOffset: 0,
      borderRadius: '12px',
      _hover: {
        boxShadow: 'none',
      },
      _focusWithin: {
        borderColor: 'podcastPurple',
        outlineWidth: '1px',
        outlineStyle: 'solid',
        outlineColor: 'podcastPurple',
        _invalid: {
          borderColor: 'AlituPink',
          outlineWidth: '1px',
          outlineColor: 'AlituPink',
        },
      },
      _invalid: {
        border: `1px solid ${colors.AlituPink}`,
        boxShadow: 'inset 0px -3px 6px rgba(239, 57, 113, 0.05)',
      },
    },
  },
  variants: {
    size: {
      small: {
        input: {
          height: '36px',
          fontSize: '13px',
        },
        control: {
          height: '36px',
          fontSize: '13px',
        },
      },
      large: {
        input: {
          height: '48px',
          padding: '20px',
          fontSize: '16px',
        },
        control: {
          height: '48px',
          fontSize: '16px',
        },
      },
    },
  },
  defaultVariants: {
    size: 'large',
  },
});

export default NumberInput;
